import { Clock } from "lucide-react";
import { SendProof } from "./SendProof";

const ICONS = {
  project_created: "🆕",
  status_changed: "🔄",
  customer_updated: "👤",
  consumption_updated: "🔥",
  technical_check_updated: "🔧",
  photo_added: "📷",
  video_added: "🎬",
  sketch_added: "✏️",
  offer_created: "📄",
  offer_pdf_generated: "📑",
  offer_sent: "📧",
  // Iter89q (2026-02-24) — differenzierte Icons für Mail-Versände.
  wp_offer_email_sent: "📧",
  pv_offer_email_sent: "📧",
  offer_send_failed: "⚠️",
  invoice_sent: "💶",
  invoice_resent: "🔁",
  invoice_paid: "✅",
  order_confirmation_sent: "📨",
  customer_bza_package_sent: "📨",
  bza_package_sent: "📨",
  manual_signature_captured: "✍️",
  pdf_regenerated: "📑",
  orientation_offer_sent: "📧",
};

export default function HistorySection({ history }) {
  if (!history || history.length === 0) {
    return <div className="text-center py-12 text-zinc-500">Noch keine Chronik-Einträge.</div>;
  }
  return (
    <div className="bg-[#18181B] border border-zinc-800 rounded-2xl p-5">
      <h3 className="font-display text-lg font-semibold mb-4 flex items-center gap-2"><Clock size={18} /> Projektchronik</h3>
      <div className="relative pl-7 space-y-4 border-l-2 border-zinc-800">
        {history.map((h) => (
          <div key={h.id} className="relative" data-testid={`history-${h.id}`}>
            <div className="absolute -left-[34px] top-1 w-6 h-6 rounded-full bg-[#18181B] border-2 border-[#00E575] flex items-center justify-center text-xs">
              {ICONS[h.action_type] || "•"}
            </div>
            <div className="text-sm">
              <div className="font-medium">{h.description}</div>
              {h.old_value && h.new_value && (
                <div className="text-xs text-zinc-400 mt-0.5">{h.old_value} → <span className="text-[#00E575]">{h.new_value}</span></div>
              )}
              <div className="text-[12px] text-zinc-300 mt-1 font-mono uppercase tracking-wider">
                {new Date(h.created_at).toLocaleString("de-DE")}
              </div>
              {h.meta?.send_proof && <SendProof proof={h.meta.send_proof} id={h.id} />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
